export default __webpack_public_path__ + "static/media/defaulUserAvatar.7718dae8.png";